import React from "react";
import { useNavigate } from 'react-router-dom';

import styles from './search/SearchVisualizers.module.css';

const Introduction: React.FC = () => {
    const navigate = useNavigate();
    
    const handleGoBack = () => navigate(-1);

return(    
    <div className={styles.container}>
        <button onClick={handleGoBack} className={styles.returnButton}>
        &larr; Return
      </button>
            <h1>Introduction</h1>
      <p className={styles.description}>
        Welcome to the DSA Visualizer! This project is an interactive tool designed to bring complex computer science concepts to life. Instead of just reading about data structures and algorithms, you can see them in action, step-by-step. The goal is to help build a strong, intuitive understanding of how these fundamental building blocks and understand the why behind each data structures.
      </p>
      <div className={styles.useCase}>
        <h3>What is Big O Notation?</h3>
        <p>Imagine you need a specific book. How you find it represents different big O complexities.</p>
        <ul>
          <li><b>O(1) — Constant Time:</b> You ask the librarian, and they instantly tell you, "It's on the shelf right behind you."The size of the library doesn't matter; the time it takes is always the same. It's instant..</li>

          <li><b>O(n) — Linear Time:</b> You have to walk down every single aisle, checking each book one-by-one until you find it. If the library doubles in size, it will take you twice as long. The time grows in a straight line with the number of books.</li>
          
          <li><b>O(logn) — Logarithmic Time:</b> You use the library's catalog. You look up the book, find its section, and go right to it. Even if the library has millions of books, it only takes a few, efficient steps to find what you need. This is extremely fast and scalable. </li>
        </ul>
      </div>
      <div className={styles.timeComplexity}>
        <h3>Time Complexity</h3>
        <p>
          As you explore the visualizers in this app, pay attention to their Big O time complexities listed on each page. You will physically see the difference between an instant O(1) operation and a slow, multi-step O(n) operation. This visual feedback is the key to understand why we use different algorithms.
        </p>

        <p>Ready to see it in action? Click on any of the sections in the navigation bar to get started!</p>
      </div>

    </div>)

}

export default Introduction